import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { VscServerProcess } from 'react-icons/vsc';
import { GrCompliance } from 'react-icons/gr';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function ListExam() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [lockLoading, setLockLoading] = useState({}); // Loading state for locking action
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchExams(1, perPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchExams = async (page, perPage) => {
    setLoading(true);
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${apiUrl}/api/exam?skip=${(page - 1) * perPage}&take=${perPage}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    setRecords(response.data.exams);
    setTotalRows(response.data.count);
    setLoading(false);
    setCount(response.data.count);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchExams(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    fetchExams(1, newPerPage);
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this Exam?')) {
      const token = localStorage.getItem('token');
      axios
        .delete(`${apiUrl}/api/exam/${id}`, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((res) => {
          setRecords(records.filter((record) => record.id !== id));
          toast.success('Exam deleted successfully');
          fetchExams(1, perPage);
        })
        .catch((err) => {
          err.response?.status === 401 && navigate('/');
          toast.error(err.response.data.message);
        });
    }
  };

  const Examlock = (id) => {
    if (
      window.confirm(
        'Are you sure you want to lock this Exam? All faculty work will be locked.'
      )
    ) {
      setLockLoading((prevState) => ({ ...prevState, [id]: true })); // Set loading state for this exam

      // Wait 2 seconds before calling the API
      setTimeout(() => {
        const token = localStorage.getItem('token');
        axios
          .post(
            `${apiUrl}/api/exam/locked/${id}`,
            {},
            {
              headers: {
                Authorization: `${token}`,
              },
            }
          )
          .then((res) => {
            setRecords(
              records.map((record) =>
                record.id === id ? { ...record, isLocked: true } : record
              )
            );
            toast.success(res.data.message);
            fetchExams(1, perPage);
          })
          .catch((err) => {
            toast.error(err.response?.data?.message);
            err.response?.status === 401 && navigate('/');
          })
          .finally(() => {
            setLockLoading((prevState) => ({ ...prevState, [id]: false })); // Stop loading for this exam
          });
      }, 2000); // 2-second delay before calling the API
    } else {
      toast.info('Exam lock canceled');
    }
  };

  const columns = [
    {
      name: 'Status',
      selector: (row) =>
        row.status ? (
          <GrCompliance className="text-success fs-4" />
        ) : (
          <VscServerProcess className="text-danger fs-4" />
        ),
      center: 'true',
      width: '65px',
    },
    {
      name: 'No',
      selector: (row, index) => index + 1 + perPage * (currentPage - 1),
      center: 'true',
      width: '50px',
    },
    {
      name: ' Exam Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Exam Program',
      selector: (row) => row?.program?.name,
      sortable: true,
    },
    {
      name: 'Actions',
      width: '235px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-primary btn-sm mx-1"
            onClick={() =>
              navigate('/examsetting', {
                state: { id: row.id, examname: row.name },
              })
            }
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Exam Setting"
          >
            <i className="bi bi-gear"></i>
          </button>
          <button
            type="button"
            className="btn btn-success btn-sm mx-1"
            onClick={() => navigate('/ExamDetails', { state: { id: row.id } })}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Exam ExamDetails"
          >
            <i className="bi bi-list-columns"></i>
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm mx-1"
            onClick={() => Examlock(row.id)}
            disabled={lockLoading[row.id]}
            data-tooltip-id="my-tooltip"
            data-tooltip-content={row.isLocked ? 'Exam Unlock' : 'Exam Lock'}
          >
            {lockLoading[row.id] ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : row.isLocked ? (
              <i className="bi bi-lock-fill"></i>
            ) : (
              <i className="bi bi-unlock-fill"></i>
            )}
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm mx-1"
            onClick={() => navigate('/EditExam', { state: { id: row.id } })}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Exam Update"
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button
            type="button"
            className="btn btn-outline-danger btn-sm mx-1"
            onClick={() => handleDelete(row.id)}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Exam Delete"
          >
            <i className="bi bi-trash3-fill"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div>
        <AdminLayout ac4="active">
          <main id="main" className="main">
            <div className="pagetitle">
              <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/AdminHome">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    View Exam ({count})
                  </li>
                </ol>
              </nav>
            </div>
            <hr className="mb-0" />
            <div className="row">
              <div className="container ">
                <div className="datatable-top">
                  <div className="datatable-search">
                    <input
                      className="form-control"
                      type="search"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate('/AddExam')}
                      data-tooltip-id="my-tooltip"
                      data-tooltip-content="Add New Exam"
                    >
                      <i className="bi bi-plus-square"></i>
                    </button>
                  </div>
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={records.filter((record) =>
                      record.name
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase())
                    )}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    className="custom-table"
                  />
                  <ToastContainer
                    position="top-center"
                    style={{ width: 'auto' }}
                  />
                </div>
              </div>
            </div>
          </main>
        </AdminLayout>
        <Tooltip id="my-tooltip" />
      </div>
    </>
  );
}
